<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content [formGroup]="form">
  <p class="secret-notice">
    The value is sent directly to AWS Secrets Manager. It cannot be viewed again in Wallit TeamAdmin.
  </p>

  <mat-form-field appearance="outline">
    <mat-label>Secret name</mat-label>
    <span matPrefix>{{ data.prefix }}</span>
    <input matInput formControlName="name" autocomplete="off" />
    <mat-hint>Use letters, numbers, +, =, ., @, _, or -.</mat-hint>
    <mat-error *ngIf="form.get('name')?.hasError('required')">Secret name is required.</mat-error>
    <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Secret name cannot exceed 128 characters.</mat-error>
    <mat-error *ngIf="form.get('name')?.hasError('pattern')">
      Secret name can only contain letters, numbers, +, =, ., @, _, or -.
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" *ngIf="data.type === 'password'; else keyValueField">
    <mat-label>{{ valueLabel }}</mat-label>
    <input matInput type="password" formControlName="value" autocomplete="new-password" />
    <mat-error *ngIf="form.get('value')?.hasError('required')">Password is required.</mat-error>
  </mat-form-field>

  <ng-template #keyValueField>
    <mat-form-field appearance="outline">
      <mat-label>{{ valueLabel }}</mat-label>
      <textarea matInput rows="12" formControlName="value" autocomplete="off"></textarea>
      <mat-error *ngIf="form.get('value')?.hasError('required')">{{ valueLabel }} is required.</mat-error>
    </mat-form-field>
  </ng-template>

  <div class="validation-summary" *ngIf="validationMessages.length" role="alert" aria-live="polite">
    <strong>Complete the following before creating the secret:</strong>
    <ul>
      <li *ngFor="let message of validationMessages">{{ message }}</li>
    </ul>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="submit()">
    Create secret
  </button>
</mat-dialog-actions>
